export { default } from './ResultsChart';
